import MisDatosPage from 'pages/MisDatos';
import SolicitudesDatosPage from 'pages/admin/SolicitudesDatos';
import Inicio from 'pages/liftlogic/Inicio';
import ConstructorPdf from 'pages/liftlogic/ConstructorPdf';
import Usuarios from 'pages/liftlogic/Usuarios';
import IDTenant from 'pages/liftlogic/IDTenant';
import Admin from 'pages/liftlogic/Admin';
import PdfTemplateEditorPage from 'pages/liftlogic/PdfTemplateEditorPage';
import MenuItemsPage from 'pages/liftlogic/v2/MenuItems/MenuItemsPage';
import SupportSettingsPage from 'pages/liftlogic/SupportSettingsPage';
import IncidentsPage from 'pages/liftlogic/Incidents/IncidentsPage';
import CorreosGlobalPage from 'pages/liftlogic/CorreosGlobalPage';
import TenantsPage from 'pages/admin/TenantsPage';
import TenantPdfTemplatesPage from 'pages/admin/TenantPdfTemplatesPage';
import TenantMenuItemsPage from 'pages/admin/TenantMenuItemsPage';
import TenantGarantiasPage from 'pages/admin/TenantGarantiasPage';
import TenantComponentTemplatesPage from 'pages/admin/TenantComponentTemplatesPage';
import TenantComponentAttributeDefsPage from 'pages/admin/TenantComponentAttributeDefsPage';
import TenantComponentTypesPage from 'pages/admin/TenantComponentTypesPage';
import TenantEquiposPage from 'pages/admin/TenantEquiposPage';
import TenantAscensorComponentsPage from 'pages/admin/TenantAscensorComponentsPage';
import TenantEditPage from 'pages/admin/TenantEditPage';

import { mainRoute, catchAllRoute } from '../helpers';

const liftlogicRoutes = [
  mainRoute('/admin/tenants', TenantsPage),
  mainRoute('/admin/tenants/:tenantId/edit', TenantEditPage),
  mainRoute('/admin/tenants/:tenantId/pdf-templates', TenantPdfTemplatesPage),
  mainRoute('/admin/tenants/:tenantId/pdf-templates/:documentType', TenantPdfTemplatesPage),
  mainRoute('/admin/tenants/:tenantId/menu-items', TenantMenuItemsPage),
  mainRoute('/admin/tenants/:tenantId/garantias', TenantGarantiasPage),
  mainRoute('/admin/tenants/:tenantId/component-templates', TenantComponentTemplatesPage),
  mainRoute('/admin/tenants/:tenantId/component-attribute-defs', TenantComponentAttributeDefsPage),
  mainRoute('/admin/tenants/:tenantId/component-types', TenantComponentTypesPage),
  mainRoute('/admin/tenants/:tenantId/equipos', TenantEquiposPage),
  mainRoute(
    '/admin/tenants/:tenantId/ascensores/:equipoId/components',
    TenantAscensorComponentsPage
  ),
  mainRoute('/', Inicio),
  mainRoute('/constructorPdf', ConstructorPdf),
  mainRoute('/tenants/:id/usuarios/', Usuarios),
  mainRoute('/tenants/:id/', IDTenant),
  mainRoute('/administrador', Admin),
  mainRoute('/pdf-templates/:documentType', PdfTemplateEditorPage),
  mainRoute('/liftlogic/menu-items', MenuItemsPage),
  mainRoute('/liftlogic/support-settings', SupportSettingsPage),
  mainRoute('/liftlogic/incidents', IncidentsPage),
  mainRoute('/liftlogic/correos', CorreosGlobalPage),
  // Ley 21.719: el super-admin entra a la bandeja para asistir al tenant, que es quien
  // decide (el backend lo habilita en denyTypes). Los datos siguen scopeados por tenant.
  mainRoute('/admin/solicitudes-datos', SolicitudesDatosPage),
  // Ley 21.719: toda persona con cuenta puede ejercer sus derechos sobre sus datos.
  mainRoute('/mis-datos', MisDatosPage),
  catchAllRoute(),
];

export default liftlogicRoutes;
